import { Location } from 'types/map';

export const defaultMapCenter: Location = {
    lat: 41.588771,
    lng: 21.697213,
};
